NtechApp.ConfirmForm = function() {
    var me = this;

    me._click = new NtechApp.TouchClickEvent();
    me._form = null;
    me._loader = null;
    me._cb = null;
    me._unloadCb = null;

    this._loadForm();
    return this;
};

NtechApp.proto(NtechApp.ConfirmForm, {
    _loadForm: function() {
        var me = this;
        me._form = new NtechApp.ModalForm(NtechApp.ModalForm.CACHE);
        me._form.setFormView($("#confirmForm"));
    },

    load: function(cb, unloadCb) {
        var me = this;
        this._cb = cb;
        this._unloadCb = (typeof unloadCb != "undefined") ? unloadCb : function() {};

        this._form.getOverlay().updateCss({zIndex: 1400});

        me._form.load("fakeroute", {}, function($form) {
            me._loader = new NtechApp.Loader(35, 35, "absolute", $form.find(".confirm"));
            me._bindFormEvents.call(me, $form);
        });
    },

    unload: function() {
        this._unloadForm();
    },

    _unloadForm: function() {
        this._form.unload();
        if(this._loader != null)
            this._loader.off();
    },

    _bindFormEvents: function($form) {
        var me = this;

        me._click.listen($form.find(".formHeader .close .button"), function(event) {
            me._unloadForm();
        });
        me._click.listen($form.find(".cancel"), function(event) {
            me._unloadCb();
            me._unloadForm();
        });
        me._click.listen($form.find(".confirm"), function(event) {
            me._loader.on().white();
            me._loader.getView().addClass("ntechapp-loader-light");
            if(typeof me._cb == "function")
                me._cb(me);
        });
    }
});